/* eslint-disable-next-line no-restricted-syntax
-- TODO: Suppression added when adding rule to recommend avoiding enums. Enums generate a lot of bundle size bloat, please consider moving to an alternate pattern. */
export var GenericEvent;
(function (GenericEvent) {
    GenericEvent["RefreshTimerTriggered"] = "RefreshTimerTriggered";
    GenericEvent["MandatoryLabelHandlerSetReadOnly"] = "MandatoryLabelHandlerSetReadOnly";
    GenericEvent["MandatoryLabelHandlerResetReadOnly"] = "MandatoryLabelHandlerResetReadOnly";
})(GenericEvent || (GenericEvent = {}));
//# sourceMappingURL=GenericEvent.js.map